import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  production: true,
  defaultFairId: '196',
  keycloakUrl: 'https://auth.bau-insights.de/auth',
  keycloakClient: 'bau365portal',
  fairDataGatewayUrl: 'https://fair-data-gateway.api.bau-insights.de/v1',
  searchUrl: 'https://search-service.api.bau-insights.de/v1',
  exportServiceUrl: 'https://document-service.api.bau-insights.de/v1',
  userUrl: 'https://user-service.api.bau-insights.de/v1',
  ticketUrl: 'https://ticket-service.api.bau-insights.de/v1',
  analyticsUrl: 'https://analytics-data-service.api.bau-insights.de/v1',
  leadServiceUrl: 'https://lead-service.api.bau365-insights.de/v1',
  basicAuth: 'YmF1MzY1OkRGdmVaSm5AM29IcWpvNmRSczkyUUZkZWU=',
  host: 'https://bau-insights.de',
  selfserviceHost: 'https://selfservice.bau-insights.de',
  iconHost: 'https://bau-insights.de/de',
  platformTitle: 'BAU Insights',
  mockApiResponses: {
    globally: false,
    modules: {},
  },
  trackers: {
    snowplow: {
      queue: false,
      trackerConfig: {
        appId: 'bau-insights',
        cookieName: 'p1tr',
        cookieSameSite: 'Lax',
        cookieLifetime: 31536000,
        postPath: '/com.planone/p1tr',
      },
      trackerId: 'p1sp',
      endpoint: 'https://p1tr.bau-insights.de',
    },
    googleAnalytics: {
      property: 'GTM-PJ3QBNT',
    },
  },
  fairsConfiguration: {
    activeFair: '196',
    bauInsights: '229',
    fairs: {
      '229': {
        name: 'INSIGHTS',
        productAtBooth: false,
        advertisements: {
          parallax: {
            enabled: true,
            siteId: 614024,
            pageIds: {
              de: 1866447,
              en: 1866448,
            },
            formats: {
              phone: 117558,
              desktop: 117559,
            },
          },
          skyscraper: {
            enabled: true,
            siteId: 614024,
            pageIds: {
              de: 1866447,
              en: 1866448,
            },
            format: 24905,
          },
        },
      },
      '185': {
        name: 'digitalBAU 2024',
        shortName: 'digitalBAU 24',
        program: {
          baseUrl: 'https://eventdatabase-live-dba-bau-insights.webserver-preview.fsnmm.de',
          tabs: [
            {
              urls: {
                de: { url: 'programm/stages/zeitplan', title: 'Foren' },
                en: { url: 'program/stages/schedule', title: 'Stages' },
              },
              name: 'stages',
            },
            {
              urls: {
                de: { url: 'programm/start-up-program/zeitplan', title: 'digitalLab Programm' },
                en: { url: 'program/start-up-program/schedule', title: 'digitalLab program' },
              },
              name: 'startupprogram',
            },
            {
              urls: {
                de: { url: 'programm/guided-tours/zeitplan', title: 'Guided Tours' },
                en: { url: 'program/guided-tours/schedule', title: 'Guided Tours' },
              },
              name: 'guidedtours',
            },
          ],
          links: [
            {
              urls: {
                de: {
                  url: 'https://digital-bau.com/de/messe/programm/start-up-area/',
                  title: 'Start-up Area Programm',
                },
                en: {
                  url: 'https://digital-bau.com/en/trade-fair/program/start-up-area/',
                  title: 'Start-up Area Program',
                },
              },
            },
            {
              urls: {
                de: { url: 'https://digital-bau.com/de/messe/programm/sonderflaeche/', title: 'Innovation Parcours' },
                en: {
                  url: 'https://digital-bau.com/en/trade-fair/program/special-areas/',
                  title: 'Innovation Parcours',
                },
              },
            },
          ],
        },
        startDate: new Date('2024-02-20'),
        endDate: new Date('2024-02-22'),
        hallplan: {
          baseUrl: 'https://maps.inforomap.de',
          scriptUrl: 'InforoMap/shared/app/build/latest/plan1/digitalbau2024/web/InforoMap.js',
          localizedUrls: {
            de: 'digitalbau2024/Html/web/de/InforoMapConfig.js',
            en: 'digitalbau2024/Html/web/en/InforoMapConfig.js',
          },
        },
        timezone: '+0200',
        productAtBooth: true,
        startupFilter: true,
        venue: $localize`:@@environment-fairs-venues-koeln:Messegelände Köln`,
        advertisements: {
          parallax: {
            enabled: false,
            siteId: 614200,
            pageIds: {
              de: 1869662,
              en: 1869663,
            },
            formats: {
              phone: 117558,
              desktop: 117559,
            },
          },
          skyscraper: {
            enabled: false,
            siteId: 614200,
            pageIds: {
              de: 1869662,
              en: 1869663,
            },
            format: 24905,
          },
        },
      },
      '196': {
        name: 'BAU 2025',
        timezone: '+0200',
        productAtBooth: true,
        startDate: new Date('2025-01-13'),
        endDate: new Date('2025-01-17'),
        venue: $localize`:@@environment-fairs-venues-muenchen:Messe München`,
        hallplan: {
          baseUrl: 'https://maps.inforomap.de',
          scriptUrl: 'InforoMap/shared/app/build/latest/plan1/bau2025/web/InforoMap.js',
          localizedUrls: {
            de: 'bau2025/Html/web/de/InforoMapConfig.js',
            en: 'bau2025/Html/web/en/InforoMapConfig.js',
          },
        },
        advertisements: {
          parallax: {
            enabled: true,
            siteId: 614024,
            pageIds: {
              de: 1866447,
              en: 1866448,
            },
            formats: {
              phone: 134093,
              desktop: 134092,
            },
          },
          skyscraper: {
            enabled: true,
            siteId: 614024,
            pageIds: {
              de: 1866447,
              en: 1866448,
            },
            format: 24905,
          },
        },
      },
    },
  },
  landingpageConfiguration: {
    discoveryFairId: '229',
    exhibitors: [
      {
        id: 'c7347c85-e9c5-4f56-8055-c837456e2975',
        fairId: '196',
      },
      {
        id: 'fcd179e5-c65d-4f53-8dc4-b0e33f66c80e',
        fairId: '196',
      },
      {
        id: '1cc723e8-c622-4d45-b1c5-c47ecc8e7b7d',
        fairId: '196',
      },
      {
        id: '7bd4b4bf-6cb3-4d0a-916a-69b622728ebf',
        fairId: '229',
      },
      {
        id: '5b2fd72d-5087-4bbb-84eb-f2a28f54ddcf',
        fairId: '229',
      },
      {
        id: '4cb815b7-151b-42f0-8e00-c340053e515e',
        fairId: '229',
      },
    ],
    products: [
      {
        id: '904aa72c-4cab-4d0d-914a-4737e1bc0036',
        fairId: '229',
      },
      {
        id: '5e1f1dbd-2677-4da9-bda9-9545a2531d06',
        fairId: '229',
      },
      {
        id: '2251f428-475e-41f1-92aa-7422aff250dd',
        fairId: '229',
      },
      {
        id: 'ef7f949c-7dc6-414c-a854-0b0680f7bce4',
        fairId: '229',
      },
    ],
    posts: [
      {
        id: 'a1608e26-930e-464a-9df1-62914fc4bcb7',
        fairId: '229',
      },
      {
        id: 'b4239a6c-90bd-4b3b-89c0-5e0d7cfb2322',
        fairId: '229',
      },
      {
        id: 'e14b24f3-f435-43c6-aff6-5c7d9db40e50',
        fairId: '229',
      },
      {
        id: '46e76566-e0cb-4cda-941c-189fe37bc921',
        fairId: '229',
      },
    ],
    defaultFilterChips: [
      {
        label: { de: 'Fassadenbaustoffe', en: 'Cladding materials' },
        filter: {
          productGroup: [
            '1b2cdaee-ee05-4c64-9463-96c2948605fb',
            'c0b25180-6c74-43c7-9f7d-4a6f84aaad8b',
            '9cd72b95-9d8f-4448-a326-732659710eac',
            '59ba624f-87d5-40a2-a5e6-092363b21222',
            'f37d9e36-1016-43e7-ab85-377d14805720',
            'c23c1a82-6bd4-475d-8d34-4b6813562fe8',
            '388169f7-6257-459a-aad9-2072cfd8e49f',
            'd785be10-accd-4fac-aa0d-9cdc4677bac9',
            'e8b4413a-8b72-46f5-ab5c-bf6e373480ec',
            '484335e5-3cb8-4ce7-a35b-710a366fa96f',
            'c9716c51-b9db-4f1e-9a79-885fdcb44fb1',
            '0b983401-53e8-4e55-ab86-5c25c1e1e95d',
            '8d5c26e1-0f9d-4777-82a1-440a30a0bd7f',
            '3adb74e8-1249-4271-ac6e-61c44b099e14',
            'a1aa7a3d-fa72-48d5-819c-2e2c930232a7',
            'bbb2d04d-6100-43fb-b65c-35e14967c8f0',
            'f1b5a230-56c2-4480-8e71-515f1138b8e7',
            'd2efaf14-b4d9-47b0-8f56-26fd2fc5658d',
            'db0950cc-ed34-42d3-9d33-fdc3b40dcb7f',
            '55fa27d4-b87f-4547-9dc6-dbcdf60efd20',
            '386cd7ab-01df-4158-985b-8fe869ac8e20',
            '472441c4-16a5-4799-a1fd-37b3f15e7e1a',
            'f53c86a6-74e5-4a8e-8bc3-c8971e040e99',
            '440c7dba-f5c1-465a-a0f4-5d1fbab38e10',
            'ebccc7d2-3836-409f-a0b4-c83657cfcff8',
            '2882d923-f2d5-4bce-bd0e-23470e116222',
            '531597d4-4236-4ac0-9b0a-2711349c81a3',
            '0f611a84-577f-4fa8-8b0d-fedfabf438a9',
            'b54af95e-964d-4bfc-adda-1126ebf09095',
            '97e41321-ed50-48de-b0ae-71bd07afb105',
            'c20d35df-ea61-4dbe-82d8-9686f7bfc614',
            '4e5152e1-ec1a-4f8c-b77e-35fc16c18bcf',
            '2f7dfc21-8548-4771-9548-08d564aff4f8',
            '39fb600f-53b4-4c6e-9108-d71ff04c6199',
            'fbc1f9d6-c8a0-402d-a8d7-0d2f5a635020',
            'e3ed6eff-1a76-45f1-be66-12cabe6d54f4',
            '2db84322-88d7-4780-8a40-e13cac26270b',
            '16c662c3-f340-46f0-a7b1-e183013691ff',
            '62a0017a-a7cf-4bfe-88f9-4cb698a17fb5',
            '2b4bb495-8910-456e-8132-3220b40d21f5',
            '99efecf8-823c-43b3-afe6-aaca5473b67d',
          ],
        },
      },
      {
        label: { de: 'Fenstertechnik', en: 'Windows and accessories' },
        filter: {
          productGroup: [
            '4a302cc6-3a69-4ed7-9f4b-7360374cea28',
            '34c1a65b-6860-40e3-a733-fafe3bbc03f7',
            'ae839bca-7dde-4b15-8ac6-c8113149ad52',
            'c619e365-e531-4e62-8fd1-c44087bd3ec5',
            'f5f0ed69-7c81-4886-a6ef-8712fdf852f3',
            '1bf5fa1d-92f8-4393-bae9-dcae5f08dcb5',
            'bedf5ce5-e74d-4fa0-b9c2-9cb95882a945',
            'b8c37cf5-171a-4750-9e76-787cef4364dc',
            '1a17bec5-006e-4344-9b86-a342a78a15ba',
            '4a2f2383-6bd3-4eaf-9205-e55cfa1445bd',
            '7ed41c15-e89c-4850-9edf-bccc3b71576c',
            '4e4f8ac9-645b-4622-ae57-954577cb60b4',
            '51286edd-cf3f-4882-9efc-8c981c770463',
            '280033c2-9dbd-4e70-83d6-e3cec6bb5979',
            '9c3bcc30-409e-4445-b105-0aeed4e16a3e',
            '608e579e-7b53-4e5f-a0bf-57fadc0c2d8b',
            '6029c811-4e68-4b3d-8458-26dace0b53db',
            '46f10360-dca0-43ee-b4a0-a723c670f197',
            'ecb747fc-e8c8-4554-979b-1cdf715ea044',
            '5d02c5a1-5b10-42e5-b9eb-efb78b2716db',
            '041d74e3-cd85-4394-ac2d-5be58c977ece',
            '39494e74-cdfc-4a0a-93db-a033250938d4',
            'cf6312c8-fff6-4ee0-8f0d-c24330238655',
            '3e044f7e-dd36-4484-ae6b-89434f40d2b7',
            '88bf37cb-6052-4faa-a956-58db55a9ef59',
            '45eda546-e290-45ee-8241-2af339c11a2a',
            '89558be0-8820-48e2-a229-a9966d1feabd',
            'e4941651-4e60-4544-b21f-ee9ac0937fc3',
            'c541fe49-09bb-4f28-857d-4e58457e01e0',
            'd581c5f1-5c53-4ea6-9f99-23500316066f',
            '7c60c74d-b37d-4a95-a647-e6448fc79670',
            'b9e9a8f0-2de1-4d73-8c77-bd0077e5d9ee',
            'aa07f118-a016-4c7d-a348-3d2d0073ce82',
            '247c5f69-df05-4b1f-a208-9e560aecf69a',
            '203424ac-f350-4c32-b0ee-91a3722a4734',
            '2ad9ebf5-cb03-451c-ae46-820b4acf8f0f',
            'db11e5ac-f855-487e-af8c-d4b64e24e5b7',
            '15094c71-5c27-4562-bca6-b76a320c477d',
            'c03eba2a-6cfc-4cb2-828c-380d008480d5',
            '1f0680a4-3b24-404d-87ff-74e279be79b8',
            'e59dbbfd-783f-4c13-82a9-cdd5c141af63',
            '1dde286d-398f-432a-9712-abb2fc3539b2',
            '77e43439-6cb5-49fc-9ef9-2bf1327161d7',
            '333ea02e-363d-46b4-8b7f-e7b038b7e062',
            'cf6a9ec4-bc45-4e97-9af1-07080bd94bc4',
            'cdc7d537-a8fe-470f-8183-2407cf6aba42',
            'add8fcae-6def-4819-aea4-b79836a94be1',
            '60258f56-ef3a-4428-af6e-76906a0de040',
            'd2c8f647-7c08-4d77-acae-9699d4cf625a',
            '616811e6-d4d0-4443-a231-bee593961d34',
            '78b63cd5-ddd7-4827-aee1-02920ea9f6ca',
            '63a7ec1a-993c-4a30-a86f-6e3f03fbe2ac',
            'f509778a-3787-4f1a-9688-96914dd195f0',
            '92af20fa-7b63-4bd4-a2cf-59f2dda2ff88',
            '8e9c4950-e205-406d-9309-4c346a055111',
            '4f2e8d7a-c0c8-4dbc-9903-4564c5d0e2a8',
            'a81d4282-3078-43c6-9eb3-5fe7d011dfaf',
            '799f74df-4998-43de-8d61-44aef9adf985',
            '0b95df6e-9ad2-4f65-97dd-f1cac4755ae3',
            'f09cb1db-b6ec-4b6a-8778-f02b626f09b9',
            '4316dde9-f56b-4486-a50a-708828f3c9df',
            '3d85ee8f-3972-484b-9902-8e18c83cca5b',
            '8d58308e-ae1e-4534-aad0-3b9dabe11a78',
            '2c9fa47e-815f-4f79-97fc-9ae6265cb031',
            'df9f7d24-90ff-420d-a378-4cd520f88f1a',
          ],
        },
      },
      {
        label: { de: 'Dämmstoffe', en: 'Insulation materials' },
        filter: {
          productGroup: [
            'e5d6291f-eb0b-40a2-ab7e-cb0910106e85',
            '6deae3f8-ad92-40b9-9c61-80fa68bd13a5',
            '5776ba25-fae2-47d2-b94c-86ce70ecd042',
            '91495882-4b25-4363-ab37-eee39ff6e860',
            '0ee22861-0f45-49bb-991e-c54b5fd4a20c',
            'e52a10cd-7f92-47d5-bf88-64d9cbf3ee81',
            'a5151c15-c881-460a-b4d4-a32a6f946cd6',
            '5fc924be-0d78-43e2-8f7d-1e58e382603b',
            '7b77b8bb-c2e2-42de-ad7f-30f1c2448c1e',
            '87b8b89c-7b15-4536-8146-1f0992097616',
            'aa554fd0-dc3e-4901-a019-7ee2f9d36bba',
            '236fa84e-912d-4d14-844e-69fb908bf696',
            'ed09c670-2496-4e9f-89db-a9fd9c5d2b7e',
            'e0d01b83-4b71-416f-bd91-c05b43b19df0',
            '4a428ddf-a1a4-46c7-90e8-f20d80747b8c',
            '1915d397-d4ef-4b81-b2df-f2bfe3c34d83',
            '245002bc-df27-43ba-8697-96bff8234d6c',
            'a7a6ec88-38d5-4056-9bd5-eb401de7a499',
            'b9a18a84-e32c-4685-94aa-2b31f556d212',
            '010f3014-7e8d-4180-8744-0fc4ce9d127a',
            'acdf5abc-6c8f-41ad-ba9e-02be73987c42',
            '36551ae6-934c-4ab9-9f3a-3d661c3b1b04',
            '46bd671a-cf18-436a-bbc8-4a00f019802b',
            '99770a12-ad86-4ff8-ad87-1dfcd86a69d6',
            '5b363e8b-ef9d-4fc5-8b1c-cff9ea450025',
            'de9eaf62-c6b5-4492-b475-8369ac1ecff6',
            '55a3ef5f-f0d8-4f68-aa6d-54058ad7184a',
            'c73f58bf-ae7c-4647-b9cc-2ec258f05b11',
            '775b9195-3134-42dd-8866-b58c438a55b3',
            'eb0c26d2-15dd-412b-a537-f88f5e747775',
            '8b09fb68-b72d-4dee-8635-1751e0ffa3ef',
            '2c6d543a-3cf9-4bc2-ae65-d78aa3ca9717',
          ],
        },
      },
      {
        label: { de: 'Baustoffe der Zukunft', en: 'Building materials of the future' },
        filter: { topic: ['74451ce7-7b81-467b-a10e-b9e7fcde7162'] },
      },
      {
        label: { de: 'Nachhaltiges Bauen', en: 'Sustainable building' },
        filter: { topic: ['c8e34ee2-a609-43f6-a933-9a9793a6f258'] },
      },
      {
        label: { de: 'Bauen im Bestand', en: 'Building redevelopment' },
        filter: { topic: ['33068430-74e1-470e-ad99-b3cd8e55990d'] },
      },
    ],
  },
  unleash: {
    url: 'https://unleash-proxy.bau-insights.de/proxy',
    clientKey: 'EaDj5TGXmM28qsUo',
    appName: 'default',
    environment: 'production',
  },
  sentry: {
    dsn: 'https://efce53fa64e148ddb5707746a51f6782@sentry-relay.bau-insights.de/6252666',
    release: 'bau365-production-v2.4.0',
    tracingOrigins: ['https://bau-insights.de'],
    tracesSampleRate: 0.01,
    showDialog: true,
    environment: 'prod',
  },
  botRegex:
    /Googlebot|bingbot|yandex|baiduspider|Facebot|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|slackbot|vkShare|W3C_Validator/i,
  spaceRegex: /^[ ]{1,}$/,
};
